import svgMapCityIds from '@cian/metro/ready';

angular.module('cian.metroBrowser').directive('metroBrowser', () => {
  return {
    scope: {},
    bindToController: {
      filter: '=',
      selectedRegions: '='
    },
    template: require('../../templates/metro-browser.html'),
    restrict: 'EA',
    controller: [
      '$element',
      '$uibModal',
      'FilterBackup',
      'AnalyticsService',
      function($element, $uibModal, FilterBackup, AnalyticsService) {
      this.isPopupOpen = false;

      this.open = () => {
        const cityId = this.selectedRegions[0].mainTownId || this.selectedRegions[0].id;
        const popupProps = svgMapCityIds.includes(cityId) ? {
          template: require('../../templates/metro-svg-browser.popup.html'),
          controller: 'MetroSvgBrowserCtrl',
        } : {
          template: require('../../templates/metro-browser.popup.html'),
          controller: 'MetroBrowserCtrl',
        };

        if (!this.isPopupOpen) {
          this.isPopupOpen = true;
          FilterBackup.backup();

          AnalyticsService.trackCA('Listing', 'popup_metro_open');

          $uibModal.open({
            ...popupProps,
            animation: true,
            windowClass: 'serp-modal serp-modal_with_header',
            controllerAs: 'modal',
            resolve: {
              regionId: () => cityId,
              geo: () => this.filter.geo,
              onlyFoot: () => this.filter.only_foot,
              footMin: () => this.filter.foot_min
            }
          }).result
            .then(null, FilterBackup.restore)
            .finally(() => this.isPopupOpen = false);
        }
      };
    }],
    controllerAs: 'metroBrowser'
  };
});



// WEBPACK FOOTER //
// ./src/components/metro-browser/src/scripts/cian.metro-browser.dir.js